'use client';

import dynamic from 'next/dynamic';

const GlobeSection = dynamic(() => import('./globe').then((m) => m.GlobeSection), { ssr: false });

interface GlobeSectionLazyProps {
  salesDemoHref?: string | null;
}

export function GlobeSectionLazy({ salesDemoHref }: GlobeSectionLazyProps = {}) {
  return <GlobeSection salesDemoHref={salesDemoHref} />;
}
